import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap font-body text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-38 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-sm hover:shadow-hover hover:-translate-y-px",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:opacity-90",
        outline:
          "bg-white text-ink border border-[#e4e1db] hover:border-ink hover:bg-paper",
        secondary:
          "bg-paper text-ink border border-[#e4e1db] hover:border-ink",
        ghost:
          "text-ink hover:bg-paper hover:text-ink",
        link:
          "text-ink underline-offset-4 hover:underline p-0 h-auto",
        accent:
          "bg-[#d4a843] text-ink shadow-sm hover:opacity-90 hover:-translate-y-px",
      },
      size: {
        default: "h-10 px-5 py-2 rounded-pill",
        sm:      "h-8 px-4 text-xs rounded-pill",
        lg:      "h-12 px-7 text-base rounded-pill",
        xl:      "h-14 px-9 text-base rounded-pill",
        icon:    "h-9 w-9 rounded-full",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
